import Vue from 'vue'
import VueResource from 'vue-resource'
import { ApiUtil as api } from '@/utils/api.util.js'

Vue.use(VueResource)

export class AttributeService {
    static URL = process.env.API_URL + process.env.API_VER
    static RESOURCE = '/attributes/'

    static all(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE, queryParams)
    }

    static show(id, queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + id, queryParams);
    }

    static create(data = {}) {
        return api.post(this.URL + this.RESOURCE, data)
    }

    static update(id, data = {}) {
        return api.put(this.URL + this.RESOURCE + id, data)
    }

    static delete(id, queryParams = {}) {
        return api.delete(this.URL + this.RESOURCE + id, queryParams)
    }

    static modelAttributes(queryParams = {}) {
        return api.get(this.URL + '/attributes-model', queryParams)
    }

    static attachModelAttributes( queryParams = {}) {
        return api.post(this.URL + '/attributes-model/attach', queryParams)
    }

    static detachModelAttributes( queryParams = {}) {
        return api.post(this.URL + '/attributes-model/detach', queryParams)
    }

    static getCodeAttribute(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'get/codes', queryParams)
    }
    static assignToggle(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'assign-toggle', queryParams)
    }
    static toggleArchive(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'toggle-archive', queryParams)
    }
    static attachAttribute(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'attach-attribute', queryParams)
    }
    static attachMandatoryTag(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'attach-mandatory-tag', queryParams)
    }
}



// WEBPACK FOOTER //
// ./src/services/attributes.service.js